module.exports = __webpack_public_path__ + "img/root-express.1c92e6bc.png";